/*******************************************************************************
 * Copyright (c) 2024 Belltane LLC
 *
 * All rights reserved.
 *
 * Contributors:
 *   Amina Rais - Initial implementation
 *
 * Version: 1.0.0
 *
 *******************************************************************************/

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';
import translations_en from './locales/en/translations_en.json';
import translations_es from './locales/es/translations_es.json';
import translations_fr from './locales/fr/translations_fr.json';

const resources = {
  en: translations_en,
  es: translations_es,
  fr: translations_fr,
}

console.log(
  'init',
  i18n
    .use(detector)
    .use(initReactI18next)
    .init({
      resources,
      lng: localStorage.getItem("lang") ? localStorage.getItem("lang") : 'en'
      ,
      debug: true,
      fallbackLng: 'en',
      keySeparator: false,
      saveMissing: true,
      interpolation: {
        escapeValue: false,
      }
    })
);

export default i18n;
